import { namespacer } from 'util/namespace';
import { TW_API_URL } from 'config';

const NAMESPACE = 'PAGES_MATCHES';

export const GET_MATCHES_REQUEST_START = namespacer(
  NAMESPACE,
  'GET_MATCHES_REQUEST_START'
);
export const GET_MATCHES_REQUEST_SUCCESS = namespacer(
  NAMESPACE,
  'GET_MATCHES_REQUEST_SUCCESS'
);
export const GET_MATCHES_REQUEST_ERROR = namespacer(
  NAMESPACE,
  'GET_MATCHES_REQUEST_ERROR'
);

export function getMatchesRequestStart() {
  return {
    type: GET_MATCHES_REQUEST_START,
  };
}

export function getMatchesRequestSuccess(matches) {
  return {
    type: GET_MATCHES_REQUEST_SUCCESS,
    matches,
  };
}

export function getMatchesRequestError(error) {
  return {
    type: GET_MATCHES_REQUEST_ERROR,
    error,
  };
}

export function getMatchesRequest(season, week) {
  return (dispatch) => {
    dispatch(getMatchesRequestStart());

    return getMatchesQuery(season, week)
      .then((matches) => {
        dispatch(getMatchesRequestSuccess(matches));
      })
      .catch((error) => {
        dispatch(getMatchesRequestError(error));
      });
  };
}

function getMatchesQuery(season, week) {
  return new Promise((resolve, reject) => {
    const url = `${TW_API_URL}/twdt/matches?season=${season}&week=${
      week || -1
    }`;

    fetch(url)
      .then((data) => data.json())
      .then(({ schedule, matches }) => {
        for (const s of schedule) {
          const match = matches.find(
            (m) => m.draft_match.fnScheduleID === s.fnScheduleID
          );

          if (match) {
            s.match = match;
          }
        }

        resolve(schedule);
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/actions/pages/matches.js